import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[tcTooltip]',
  standalone: true
})
export class TooltipDirective {

   @Input() positionStatic: boolean = false;
  
  @HostListener('mouseover')
  onMouseOver() {
    if(this.positionStatic){
      return
    }
    const elRect = this.el.nativeElement.getBoundingClientRect();
    const child = this.el.nativeElement.getElementsByClassName('tooltip-text')[0];
    const right = document.body.clientWidth  - (elRect.left + this.el.nativeElement.clientWidth)
    if(elRect.top < elRect.bottom){
       child.classList.remove('tooltip-top');
       child.classList.add('tooltip-bottom')
    }
    else{
      child.classList.remove('tooltip-bottom');
      child.classList.add('tooltip-top')
    }
    if(elRect.left < 100){
      child.classList.add('tooltip-left')
      child.classList.remove('tooltip-right')
    }
    else if (right < 100){
      child.classList.add('tooltip-right')
      child.classList.remove('tooltip-left')
    }
    else{
      child.classList.remove('tooltip-right')
      child.classList.remove('tooltip-left')
    }
  }

  @HostListener('mouseout')
  onMouseOut() {
  }

  constructor(
    private el: ElementRef
  ) {
   }
}
